// 로그인 후 "최종 이용 페이지" 복원용.
// 인증된 앱(DefaultLayout) 페이지 경로만 저장하고, 로그인/온보딩/카페24 콜백 등
// SignOutLayout 계열 경로는 저장/복원에서 제외한다(로그인 화면으로 되돌아가는 것 방지).
import { reactLocalStorage as Storage } from 'reactjs-localstorage';

const KEY = 'orp_last_path';
const DEFAULT_PATH = '/dashboard';

// 저장/복원 제외 경로 (인증 전·콜백·온보딩)
const EXCLUDE = [
  '/', '/signIn', '/signUp', '/starter', '/welcome',
  '/serviceAgree', '/privateAgree',
  '/cafe', '/cafe24', '/cafeRedirect',
  '/cafeInAppOrderReturnUrl', '/cafeMsgOrderReturnUrl'
];

// 현재 경로를 최종 이용 페이지로 저장 (라우트 변경 시 호출)
export const saveLastPath = (pathname) => {
  try {
    if (!pathname || typeof pathname !== 'string') return;
    if (EXCLUDE.indexOf(pathname) > -1) return;
    Storage.set(KEY, pathname);
  } catch (e) { /* ignore */ }
};

// 저장된 최종 이용 페이지 반환 (없거나 제외 경로면 기본값)
export const getLastPath = () => {
  try {
    const p = Storage.get(KEY);
    if (p && typeof p === 'string' && p.charAt(0) === '/' && EXCLUDE.indexOf(p) === -1) {
      return p;
    }
  } catch (e) { /* ignore */ }
  return DEFAULT_PATH;
};

export default { saveLastPath, getLastPath };
